// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"cd72b0b3","367":"31d6cfe0","609":"53204f71","792":"b623cb60"}[chunkId] + ".chunk.css";
};